<template>
  <b-tab title="HB Ürünleri">
    <b-row>
      <b-col cols="12" class="text-right">
        <b-button variant="info" size="sm" @click="hbMatching(product.id )">HB SKU Ekle</b-button>
      </b-col>
    </b-row>
    <b-row class="border">
      <b-col cols="2">
        id
      </b-col>
      <b-col cols="2">
        Durum
      </b-col>
      <b-col cols="2">
        Resim
      </b-col>
      <b-col cols="2">
        Hb Sku
      </b-col>
    </b-row>
    <b-row v-for="hbProduct in hbProducts" :key="hbProduct.id" class="border">
      <b-col cols="2">
        {{ hbProduct.id }} <a :href="'https://www.hepsiburada.com/w-p-'+hbProduct.merchant_sku" target="newTab">
        <feather-icon icon="HomeIcon"/>
      </a>

      </b-col>
      <b-col cols="2">
        <span v-if="hbProduct.pivot.status===0">Onay Bekliyor</span>
        <span v-if="[1,2].includes(hbProduct.pivot.status)">Onaylandı</span>
        <span v-if="[3,4].includes(hbProduct.pivot.status)">Red Edilmiş</span>
        <span v-if="hbProduct.pivot.status===5">Ertelenmiş</span>
      </b-col>
      <b-col cols="2">
        Resim
      </b-col>
      <b-col cols="2">
        {{ hbProduct.merchant_sku }}
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import addMpMatching from '@/mixins/addMpMatching'

export default {
  name: "HbProductTab",
  mixins: [addMpMatching],
  props: {
    product: {
      type: Object,
      required: true,
    },
    hbProducts: {
      type: Array,
      required: true
    }
  }
}
</script>